const content = (state = {}, action) => {
	switch (action.type) {
		case 'SET_HOME_CONTENT':
			return { home: action.content };
		default:
			return state;
	}
};
export default content;
